import React from 'react';
import { motion } from 'framer-motion';
import Card from '../components/common/Card';

const Help = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Help & Support</h1>
          <p className="text-xl text-gray-600">Get help with using the HRMS system</p>
        </motion.div>

        <Card>
          <Card.Header>
            <h3 className="text-lg font-semibold">Frequently Asked Questions</h3>
          </Card.Header>
          <Card.Body>
            <p className="text-gray-600">Help documentation will be implemented here</p>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default Help;